<div class="tips"><img referrerpolicy="no-referrer" src="../../../../assets/images/tips@2x.png " /></div>
<mat-icon class="close" mat-dialog-close>close</mat-icon>

<ng-container>
  <div class="selection duration">
    <div>
      <div>您可以用以下的结构来写您的提示词（当然不是必须的）：</div>

      <div style="color:#951D1D">主体 + 描述性细节 + 环境或背景 + 风格 + 光影和色彩 + 参数或修饰词</div>

      <div class="height"></div>

      <div>主体（主体物）这是你希望在图像中主要表现的对象，主体决定了图像的核心内容。</div>

      <div>例如，"一位穿着西装的绅士"、"一片宁静的森林"等。</div>

      <div class="height"></div>

      <div>描述性细节通过描述颜色、形状、材质等细节来丰富图像，帮助 AI 生成更符合预期的画面。</div>

      <div>例如，“闪亮的金色盔甲”、“柔和的晨光下的湖面”等。</div>

      <div class="height"></div>

      <div>环境或背景描述主体所在的环境，背景为主体提供了一个上下文，帮助形成整体的视觉场景。</div>

      <div>例如，“在雪山之巅”、“古老的石头城堡内部”等。</div>

      <div class="height"></div>

      <div>风格描述图像的艺术风格或表现形式，风格会极大影响图像的视觉感受。</div>
      <div>例如，"赛博朋克风格"、"油画风格"等。</div>

      <div class="height"></div>

      <div>光影和色彩可以用来控制图像的氛围，光影和色彩能够显著影响图像的情感和氛围。</div>

      <div>例如，“暖色调夕阳下”、“冷蓝色调的夜晚”等。</div>


      <div class="height"></div>
      <div>使用修饰词来进一步细化生成图像的特征，这些词语帮助控制图像的视觉层次和复杂性例如，</div>

      <div>例如，“简洁”、“复杂”、“现代”、“古典”等。</div>
    </div>

  </div>
</ng-container>